export const isValidUrl = (url) => {
  return /^(http|https):\/\//.test(url);
};

export const addhttp = (url) => {
  if (!isValidUrl(url)) {
    url = `https://${url}`;
  }
  return url;
};

export const getTrackingUrl = ({
  trackingUrl,
  trackingNumber
}) => {
  if (trackingUrl && !trackingUrl.includes('tracking://')) {
    return addhttp(trackingUrl);
  }

  if (trackingNumber && (trackingNumber.startsWith('1Z') || trackingNumber.length === 18)) {
    return `https://wwwapps.ups.com/tracking/tracking.cgi?tracknum=${trackingNumber}`;
  }

  return null;
}